<template>
  <v-container fluid class="list-rbu">
    <v-row class="flex-grow-0">
      <h3>{{ $t("app_drawer.rbu") }}</h3>
      <v-btn
        v-if="canCreateRbu"
        color="primary"
        class="ml-4"
        small
        @click="createRbu"
      >
        <v-icon>mdi-plus</v-icon>
        {{ $t("new") }}
      </v-btn>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col>
        <RbuEditionList
          full-height
          :refresh-trigger.sync="refreshTrigger"
        ></RbuEditionList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref, computed } from "@vue/composition-api";
import CreateRbuEditionDialog from "@/components/rbu/CreateRbuEditionDialog.vue";
import { PERMISSIONS, USER_TYPE } from "@/constants";
import RbuEditionList from "@/components/rbu/RbuEditionList.vue";

export default {
  name: "RbuEditions",
  components: { RbuEditionList },
  setup(props, { root }) {
    const createRbu = async function () {
      const editionId = await root.$dialog.showAndWait(CreateRbuEditionDialog, {
        showClose: false,
        persistent: true,
      });

      if (editionId) {
        root.$router.push({
          name: "rbu-edition-detail",
          params: { editionId },
        });
      }
    };

    const canCreateRbu = computed(() => {
      if (!root.$store.getters.account) return false;
      return [USER_TYPE.SUPER_ADMIN, USER_TYPE.ADMIN].includes(
        root.$store.getters.account.type
      );
    });

    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    return {
      createRbu,

      refreshTrigger,
      refresh,

      PERMISSIONS,
      canCreateRbu,
    };
  },
};
</script>

<style lang="less">
.list-rbu {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
